<template>
    <v-layout row justify-center>
        <v-dialog v-model="show" persistent max-width = 600px >
            <v-stepper v-model="step" alt-labels>
                <v-stepper-header>
                    <v-stepper-step :complete="step === 1" step="1">Define a Document Group</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :complete="step === 2" step="2">Define a Document Rule Container</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :complete="step === 3" step="2">Manage Document Rule Container</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="4">Define a User</v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                    <v-stepper-content step="1">
                        <documentGroupStepper
                                @closeStepper = "show = $event"
                                @stepper ="step = $event" >
                        </documentGroupStepper>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                        <documentRuleStepper
                                @closeStepper = "show = $event"
                                @stepper = "step = $event">
                        </documentRuleStepper>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                        <documentRuleManagerStepper
                                @closeStepper = "show = $event"
                                @stepper = "step = $event">
                        </documentRuleManagerStepper>
                    </v-stepper-content>
                    <v-stepper-content step="4">
                        <userStepper @closeStepper = "closeSt">
                        </userStepper>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-dialog>
    </v-layout>
</template>

<script>
    const documentGroupStepper = ()=> import( './DocumentGroupDefine');
    const documentRuleStepper = ()=> import( './DocumentRuleDefine');
    const documentRuleManagerStepper = ()=> import( './DocumentRuleManager');
    const userStepper = ()=> import( './UserDefine');
    import {USER_TYPE} from '../../../shared/enums/UserType';
    import {EmployeeType, ClientType} from '../../../shared/dtos/Dtos'

    export default {
        name: "WelcomeStepper",
        components:{
            documentGroupStepper, documentRuleStepper, documentRuleManagerStepper, userStepper
        },
        data(){
            return{
                step: 1,
                show: true
            }
        },
        methods:{
            async closeSt(event) {
                if(event){
                    //check for completion of the phases
                    let docs = this.$store.getters.getDocumentRules;
                    let docMaps = new Map();
                    for(let doc of docs){
                        try{
                            await this.$store.dispatch('setDocumentRule', doc);
                            let savedDoc = this.$store.getters.getDocumentRule;
                            docMaps.set(savedDoc.id, savedDoc);
                        }
                        catch (e) {
                            throw 'Error saving doc.'+ e;
                            //TODO throw exception and display alert
                        }
                    }

                    //save documentGroup
                    let documentGroup =  this.$store.getters.getDocumentGroup;
                    documentGroup.documentRules = docMaps;
                    try {
                        await this.$store.dispatch('setDocumentGroup', documentGroup);
                        documentGroup = this.$store.getters.getDocumentGroup;
                    }
                    catch (e) {
                        throw 'Error saving documentGroup';
                        //TODO throw exception and display alert
                    }

                    //create groupType based on documentGroup type
                    try{
                        let map = new Map();
                        switch (documentGroup.type) {
                            case USER_TYPE.EMPLOYEE: {
                                let employeeType = {...EmployeeType};
                                employeeType.name = 'Analyst_example';
                                map.set(documentGroup.id, documentGroup.name);
                                employeeType.documentGroups = map;
                                this.$store.dispatch('setEmployeeType', employeeType);
                            }
                                break;
                            case USER_TYPE.CLIENT: {
                                let clientType = {...ClientType};
                                clientType.name = 'Medicare_example';
                                map.set(documentGroup.id, documentGroup.name);
                                clientType.documentGroups = map;
                                this.$store.dispatch('setClientType', clientType);
                            }
                                break;
                            default:
                                throw 'No documentGroup type define: ' + documentGroup.type
                        }
                    }
                    catch (e) {
                        throw e;
                    }
                    //create client or employee

                   //we need to save user
                    try {
                        let user = this.$store.getters.getCognitoUser;
                        if(user !== null) {
                            await this.$store.dispatch('setCognitoUser', user);
                            this.setAlert('success', 'An email have been sent to this email address: ' +
                                this.user.attributes.email + '. Please check mail box for verification of the account')
                            this.$emit('submit', true);
                            this.showSubmit = false;
                        }
                    }
                    catch (e) {
                        this.$emit('submit', false)
                        //TODO throw exception and display alert
                    }
                }

                console.log('closing stepper!!');
                this.show = false;
            }
        }
    }
</script>

<style scoped>

</style>